'use strict';
import moment from 'moment';

export default class UpdateFormController {
  errors = {
    saveUpdate: undefined,
    other: undefined
  };
  message = '';
  submitted = false;

  today = new Date();

  year = new Date().getFullYear();
  yearsToList = 2;
  years = [];

  sites = ['Ferries', 'Water Taxi', 'Freight'];
  tags = ['Service Updates', 'Weather', 'Updates', 'News', 'Season Parking', 'Events'];

  /*@ngInject*/
  constructor(Upload, Updates, update, $state, Slug, marked, $sce) {
    this.$sce = $sce;
    this.$marked = marked;
    this._$state = $state;
    this._Updates = Updates;
    this.$Uploader = Upload;
    this.$Slug = Slug;

    this.loading = false;

    this.renderedHTML = '';
    //
    // // timeDate to set date the same for all times
    // this.timeDate = '2001-01-01';
    //
    this.mission = null;
    //
    // this.printableData = null;
    // for(var i = 0; i <= this.yearsToList; i++) {
    //   this.years.push(this.year + i);
    // }
    // this.setTimes();
    // console.log('Update');
    // console.log(schedule);
    if(!update) {
      this.setUpdate();
    } else {
      this.data = update;
      this.updateMarkdown(this.data.content);
      if(this.data.publishDate) {
        this.data.publishDate = new Date(this.data.publishDate);
      }
    }
    // this.setDays();
    //
    // this.today = new Date();
    //
    // // Key for days (numerical) to string 0 => Sunday, etc.
    // this.dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    //
    if(this._$state.current.name == 'update.edit') {
      this.mission = 'edit';
      this.pageTitle = 'Edit Update';
    } else {
      this.mission = 'new';
      this.pageTitle = 'Create New Update';
    }
  }

  updateMarkdown(input) {
    if(input) {
      this.renderedHTML = this.$sce.trustAsHtml(this.$marked(input));
    } else {
      this.renderedHTML = '';
    }
  }

  slugify(input) {
    return this.$Slug.slugify(input);
  }

  deleteImage() {
    this.data.image = '';
  }

  changeStatus() {
    if(this.data.status == 'Live') {
      this.data.publishDate = new Date();
    }
    if(this.data.status == 'Draft') {
      this.data.publishDate = null;
      this.data.publishTime = null;
    }
  }

  // Upload Printable Update
  upload(file) {
    // Set boolean for spinner to enable/disable
    this.uploading = false;
    console.log(file);

    // Use ng-file-upload to upload to express route
    this.$Uploader.upload({
      url: '/api/updates/upload',
      fields: {
        test: 'thisisatest'
      },
      file
    }).progress(evt => {
      // Show spinner while uploading/waiting for response
      this.uploading = true;

      // Calculate progress
      // Doesn't work considering AWS upload
      let progressPercentage = parseInt(100.0 * evt.loaded / evt.total, 10);
      this.percentageLoaded = progressPercentage;
      console.log(`progress: ${progressPercentage}% ${evt.config.file.name}`);
    })
    .success(data => {
      // Upon success, add link and file data to schedule
      this.data.image = data.link;
      // Turn off spinner
      this.uploading = false;
      console.log(data);
    });
  }

  setUpdate() {
    this.data = {
      title: '',
      icon: '',
      slug: '',
      excerpt: '',
      content: '',
      level: 'Normal',
      location: '',
      image: '',
      frontPage: false,
      sites: [],
      tags: [],
      email: {
        send: false,
        sent: false,
        date: ''
      },
      publishDate: '',
      publishTime: '',
      status: 'Draft'
    };
  }

  zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
  }

  saveUpdate(form) {
    this.submitted = true;
    console.log(form);
    if(form.$valid) {
      if(this.data.status == 'Draft' && this.data.publishDate) {
        this.data.publishTime = this.data.publishTime || '03:00';
        let publishDate = moment(this.data.publishDate).format('MM/DD/YYYY');
        this.data.publishDate = moment(`${publishDate} ${this.data.publishTime}`, 'MM/DD/YYYY HH:mm').format();
      }
      this.loading = true;
      this._Updates.save(this.data)
          .then(res => {
            this.loading = false;
            console.log('Result', res);
            this._$state.go('update.list');
          })
          .catch(err => {
            this.loading = false;
            console.log('Error', err);
            this.error.saveUpdate = err.data.message;
          });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/update/form/form.controller.js